function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".adjust{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "adjust",
  fill: "currentColor",
  d: "M302.4,419.7a4.88,4.88,0,0,0-4.1-4.1,5,5,0,0,0-5.7,5.7,4.88,4.88,0,0,0,4.1,4.1A5,5,0,0,0,302.4,419.7Zm-1.8,2.5h-3.7a1,1,0,0,1-.9.6,1,1,0,0,1-.9-.6h-.6a.4.4,0,0,1,0-.8h.6a1,1,0,0,1,.9-.6,1,1,0,0,1,.9.6h3.7a.4.4,0,0,1,0,.8Zm0-2.6h-.7a1,1,0,0,1-.9.6,1,1,0,0,1-.9-.6h-3.6a.4.4,0,1,1,0-.8h3.6a1,1,0,0,1,.9-.6,1,1,0,0,1,.9.6h.7a.4.4,0,0,1,0,.8Z",
  transform: "translate(-292.54 -415.54)"
});

function SvgIconAdjust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.91 9.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdjust);
export default __webpack_public_path__ + "static/media/icon-adjust.8c5ae845.svg";
export { ForwardRef as ReactComponent };